import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export default class GlobalResolver {
  private resolve: ((value: unknown) => void) | null = null;
  private reject: (() => void) | null = null;

  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  startPromise(callback: () => void | Promise<void>) {
    if (this.reject) {
      this.reject();
    }

    return new Promise(async (resolve, reject) => {
      await callback();
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  resolvePromise(value?: unknown) {
    if (!this.resolve) {
      throw `There is no current promise started.`;
    }

    this.resolve(value);
  }

  rejectPromise() {
    if (!this.reject) {
      throw `There is no current promise started.`;
    }

    this.reject();
  }
}
